<form role="form" [formGroup]="classSetForm">
    <h1 mat-dialog-title>Class Set</h1>
    <div mat-dialog-content>
      <p>{{data.title}}</p>
      
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Name of Class Set</mat-label>
          <input matInput formControlName="name" placeholder="Enter the name of class set">
        </mat-form-field>
      </p>
      <p>
        <mat-form-field appearance="outline">
          <mat-label>Description</mat-label>
          <input matInput formControlName="description" placeholder="Enter a description of the class set">
        </mat-form-field>
      </p>
      
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()">Close</button>
      <button mat-button [mat-dialog-close]="" cdkFocusInitial (click)="addClassSet()">Save</button>
    </div>
</form>
